import React from "react"
import { Link } from "gatsby"

import TeamImg1 from "../../assets/images/team/team-img1.webp"
import TeamImg2 from "../../assets/images/team/team-img2.webp"
import TeamImg3 from "../../assets/images/team/team-img3.webp"
import TeamImg4 from "../../assets/images/team/team-img4.webp"
import TeamImg5 from "../../assets/images/team/team-img5.webp"
import TeamImg6 from "../../assets/images/team/team-img6.webp"

const OurTeamStyleOne = () => {
  return (
    <>
      <div className="team-area ptb-100">
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-lg-3 col-md-6 col-sm-6"
              data-aos="fade-in"
              data-aos-duration="1200"
              data-aos-delay="100"
            >
              <div className="single-team-box">
                <img src={TeamImg1} alt="team-image" />

                <div className="content">
                  <a href="https://fpt.ai/vi/tuong-lai-cua-cong-nghe-ocr-song-hanh-cung-ai"><h3>Tương lai của công nghệ OCR song hành cùng AI</h3></a>
                  <span>FPT.AI</span>
                </div>

                <ul className="social-link">
                  <li>
                    <a
                      href="https://www.facebook.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.twitter.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="col-lg-3 col-md-6 col-sm-6"
              data-aos="fade-in"
              data-aos-duration="1200"
              data-aos-delay="200"
            >
              <div className="single-team-box">
                <img src={TeamImg2} alt="team-image" />

                <div className="content">
                  <a href=""><h3>OCR Tiếng Việt gia tăng hiệu quả làm việc đa ngành</h3></a>
                  <span>VinAI</span>
                </div>

                <ul className="social-link">
                  <li>
                    <a
                      href="https://www.facebook.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.twitter.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="section-title">
                <span className="sub-title">Tin tức</span>
                <h2>Thông tin mới nhất về APCV & Thị giác máy tính</h2>

                <Link to="/blogs" className="learn-more-btn">
                  <i className="left-icon flaticon-next-button"></i>
                  Xem tất cả <i className="right-icon flaticon-next-button"></i>
                </Link>
              </div>
            </div>

            <div
              className="col-lg-3 col-md-6 col-sm-6"
              data-aos="fade-in"
              data-aos-duration="1200"
              data-aos-delay="300"
            >
              <div className="single-team-box">
                <img src={TeamImg3} alt="team-image" />

                <div className="content">
                  <a href="https://ictvietnam.vn/giai-phap-make-in-viet-nam-su-dung-ai-camera-de-giam-sat-an-ninh-23594.html"><h3>Giải pháp Make in Viet Nam sử dụng AI camera để giám sát an ninh</h3></a>
                  <span>ictvietnam</span>
                </div>

                <ul className="social-link">
                  <li>
                    <a
                      href="https://www.facebook.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.twitter.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="col-lg-3 col-md-6 col-sm-6"
              data-aos="fade-in"
              data-aos-duration="1200"
              data-aos-delay="400"
            >
              <div className="single-team-box">
                <img src={TeamImg4} alt="team-image" />

                <div className="content">
                <a href="https://www.adtek.vn/dot-pha-giai-phap-camera-ai-giam-sat-hieu-qua/"><h3>ĐỘT PHÁ GIẢI PHÁP CAMERA AI GIÁM SÁT HIỆU QUẢ</h3></a>
                  <span>Adtek</span>
                </div>

                <ul className="social-link">
                  <li>
                    <a
                      href="https://www.facebook.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.twitter.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="col-lg-3 col-md-6 col-sm-6"
              data-aos="fade-in"
              data-aos-duration="1200"
              data-aos-delay="500"
            >
              <div className="single-team-box">
                <img src={TeamImg5} alt="team-image" />

                <div className="content">
                <a href="https://dantri.com.vn/khoa-hoc-cong-nghe/nam-2024-tri-tue-nhan-tao-se-co-nhung-dinh-hinh-the-gioi-moi-20240104124634055.htm"><h3>Định danh xác thực điện tử trong chuẩn hóa dữ liệu danh tính cá nhân</h3></a>
                  <span>Dantri</span>
                </div>

                <ul className="social-link">
                  <li>
                    <a
                      href="https://www.facebook.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.twitter.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="col-lg-3 col-md-6 col-sm-6"
              data-aos="fade-in"
              data-aos-duration="1200"
              data-aos-delay="600"
            >
              <div className="single-team-box">
                <img src={TeamImg6} alt="team-image" />

                <div className="content">
                <a href="https://vnexpress.net/giai-phap-so-hoa-van-ban-thang-giai-ai-solution-4553358.html"><h3>Giải pháp số hóa văn bản thắng giải AI Solution</h3></a>
                  <span>Vnexpress</span>
                </div>

                <ul className="social-link">
                  <li>
                    <a
                      href="https://www.facebook.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.twitter.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bx bxl-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OurTeamStyleOne
